import React, { Component } from "react";
import { ListItem } from "material-ui/List";
import * as colors from "../constants/colors";
import * as globalStyles from "../constants/styles";
import { changeColor } from "../util/color";
import InfoBox from "./InfoBox";

export default class Position extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
  }

  _openBox = ev => {
    ev.preventDefault();
    this.setState({
      open: true,
      anchorEl: ev.currentTarget
    });
  };

  _closeBox = () => {
    this.setState({
      open: false
    });
  };

  render() {
    const { name, info, position, gamePoints, totalPoints } = this.props;
    const { anchorEl, open } = this.state;
    return (
      <ListItem innerDivStyle={styles.container} onClick={this._openBox}>
        <div style={styles.position}>{position}</div>
        <div style={styles.name}>{name}</div>
        <div style={styles.games}>
          {gamePoints.map((points, index) => {
            return (
              <div key={`points-${index}`} style={styles.gamePoints}>
                {points || <div style={styles.emptyPoint}>-</div>}
              </div>
            );
          })}
        </div>
        <div style={styles.totalPoints}>{totalPoints} p</div>
        <InfoBox
          anchor={anchorEl}
          open={open}
          onClose={this._closeBox}
          info={info}
        />
      </ListItem>
    );
  }
}

const styles = {
  container: {
    display: "flex",
    alignItems: "center"
  },
  position: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: colors.grey,
    color: changeColor(colors.grey, 0.2),
    width: globalStyles.space * 2,
    height: globalStyles.space * 2,
    borderRadius: globalStyles.space,
    marginRight: globalStyles.space * 2
  },
  name: {
    flex: 1
  },
  games: {
    flex: 1,
    display: "flex",
    marginLeft: globalStyles.space * 2
  },
  gamePoints: {
    flex: 1,
    display: "flex",
    justifyContent: "center"
  },
  emptyPoint: {
    color: changeColor(colors.grey, 0.2)
  },
  totalPoints: {
    marginLeft: globalStyles.space * 2,
    fontWeight: 700
  }
};



// WEBPACK FOOTER //
// ./src/components/Position.js